import React from 'react';
import styled from 'styled-components';
import NextMarket from './NextMarket';
import media from '../styles/media';

const TopMarketBanner = () => {

    return (
        <StyledBanner>
            <div className='announcement-banner'>
                <NextMarket />
            </div>
        </StyledBanner>
    )
}

export default TopMarketBanner;

const StyledBanner = styled.div`
    background: #582C83;
    overflow: hidden;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10000;
    text-align: center;
    transition: height .3s cubic-bezier(.23,1,.32,1);

    .announcement-banner { 
        display: flex;
        justify-content: center;
        color: #fff;
        font-size: 10px;
        font-weight: 500;
        font-style: normal;
        padding: .8em 3em;
        letter-spacing: 1.9px;
        line-height: 1.2em;
        height: 26px;

    }


    .post-PageDesc {
        white-space: nowrap;
        padding-left: 3px;
    }

    ${media.mobileS`
        .announcement-banner { 
            flex-direction: column;
            line-height: 1.8em;

        }
    `}

    ${media.tablet`
        .announcement-banner { 
            flex-direction: row;
            line-height: 1em;
        }
    `}

`